/* @ngInject */
const myPiecesForm = (
  toaster,
  valueHandler,
  $$piece
) => {
  return {
    restrict: 'E',
    scope: {
      pieces: '=myPieces',
      enableValidator: '=',
    },
    template: require('./myPiecesForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.addPiece = () => {
        $scope.pieces.push($$piece.new())
      }

      $scope.removePiece = async (_index) => {
        const id = $scope.pieces[_index].id
        if (valueHandler.isId(id)) {
          try {
            const message = await $$piece.request.delete(id)
            toaster.message(message)
            $scope.pieces.splice(_index, 1)
          } catch (error) {
            toaster.error(error)
          }
        } else {
          $scope.pieces.splice(_index, 1)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myPiecesForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/directives/forms/myPiecesForm.js